package app.api

import app.client
import app.model.PaginatedResponse
import app.model.RolloutExecution
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.Job
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class RolloutExecutionPaginatedApi : RootStore<PaginatedResponse<RolloutExecution>>(
    PaginatedResponse(emptyList(), 0, 0, 0, 10),
    job = Job()
) {
    data class PaginationRequest(
        val id: String,
        val order: String,
        val page: Int,
        val pageSize: Int = 5
    )
    val handler = handle { _, req: PaginationRequest ->
        val releaseId = req.id.toInt()
        client.get(
            Routing.RolloutExecutions.SortByReleaseId(
                releaseId = releaseId,
                order = req.order,
                page = req.page,
                size = req.pageSize,
            )
        ).body<PaginatedResponse<RolloutExecution>>()
    }

    val newRolloutExecution = handle { state, data: Routing.RolloutExecutions.NewByCompanyName.Body ->
        val rolloutExecution = client.post(
            Routing.RolloutExecutions.NewByCompanyName()
        ) {
            contentType(ContentType.Application.Json)
            setBody(Json.encodeToString(data))
        }.body<List<RolloutExecution>>()
        state.copy(items = rolloutExecution + state.items)
    }
}
